// @flow

import type {Action} from '../../types'
import type {MapState} from '../types'
import type {SetServiceProvidersPayload} from '../actions/setServiceProviders'

export function setServiceProvidersReducer(state: MapState, action: Action<SetServiceProvidersPayload>): MapState {

  return {
    ...state,
    serviceProviders: action.payload.serviceProviders,
  }
}
